<template>
  <div>
    <b-badge
      v-if="step === stepTypes.OFFICE.toString()"
      variant="light-warning"
      class="mr-2"
    >
      Por asignar
    </b-badge>
    <b-avatar
      v-if="step === stepTypes.OFFICE.toString()"
      rounded
      v-b-tooltip="'Por asignar'"
      size="28"
      variant="light-warning"
    >
      <feather-icon
        size="18"
        icon="LoaderIcon"
      />
    </b-avatar>
    <b-badge
      v-if="step === stepTypes.OFFICER.toString()"
      variant="light-info"
      class="mr-2"
    >
      Asignado
    </b-badge>
    <b-avatar
      v-if="step === stepTypes.OFFICER.toString()"
      rounded
      v-b-tooltip="'Asignado'"
      size="28"
      variant="light-info"
    >
      <feather-icon
        size="18"
        icon="ShuffleIcon"
      />
    </b-avatar>
  </div>
</template>
<script>
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';

export default {
  props: {
    step: { type: String, required: true }
  },
  data() {
    return {
      stepTypes: StepTypes
    };
  }
};
</script>
